import { createContext, useContext } from 'react';

import { InternalChartToolbarConfigured } from '../../core/types/toolbar.js';

export const ToolbarContext = createContext<
  InternalChartToolbarConfigured | undefined
>(undefined);

export const useToolbarConfig = () => useContext(ToolbarContext);

ToolbarContext['displayName'] = 'ToolbarContext';
